export default {
    mutations: {
        
    },
    actions: {
        completeRecharge({commit}, payload){
            let url = '/wallet/recharge';
               
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    commit('UPDATE_USER_CREDITS', response.data.balance)
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
    }
}